import { InputSize, InputTheme, InputType } from 'components/common/types/Input.types';
import searchSvg from 'assets/icons/search.svg';
import Input from 'lib/Input';
import { SearchProps } from './Search.types';

const Search = ({
  size = InputSize.MEDIUM,
  theme = InputTheme.LIGHT,
  isRequired = false,
  isDisabled = false,
  label = '',
  value = '',
  placeholder = '',
  onBlur = undefined,
  onChange = undefined,
  id = 'search-input',
  dataTestId = 'search-input',
}: SearchProps): React.ReactElement => {
  const endIconSvg = !value && searchSvg;

  return (
    <Input
      id={id}
      dataTestId={dataTestId}
      label={label}
      value={value}
      placeholder={placeholder}
      size={size}
      theme={theme}
      onBlur={onBlur}
      onChange={onChange}
      isRequired={isRequired}
      isDisabled={isDisabled}
      type={InputType.SEARCH}
      endIconSvg={endIconSvg}
    />
  );
};

export default Search;
